import React from "react";
import { Box, Stack, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import CloseButton from "./Buttons/CloseButton";
import ActionButton from "./Buttons/ActionButton";

const Confirmation = (props) => {
  const performAction = async (e) => {
    e.preventDefault();
    // check if user typed yes or not
    props.confirmationActionCall();
    // closePopupOnClose is passed when we don't want to close the popup on action completion
    if (typeof props.closePopupOnClose === "undefined") {
      props.closePopup();
    }

  };

  return (
    <Dialog
      open={props.showConfirmationPopup}
      onClose={(e) => {
        e.preventDefault();
      }}
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle>{props.confirmationTitle}</DialogTitle>
      <DialogContent>
        <Box>
          <Typography variant="body2"> {props.confirmationMessage} </Typography>
        </Box>
      </DialogContent>
      <Box height={2} />
      <DialogActions>
        <Stack direction={"row"} spacing={2}>
          <CloseButton
            onClick={(e) => {
              e.preventDefault();
              props.closePopup();
            }}
            label={"No"}
            icon={<Close />}
          />
          <ActionButton onClick={performAction} label={"Yes"} icon={<Check />} />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default Confirmation;
